import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import { paragraphRegular } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import BrandCardStyles from '@stories/Components/Cards/BrandCard/BrandCard.styles';
import FiltersStyles from '@stories/Components/Listings/Filters/Filters.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  overflow: hidden;

  ${SectionWrapperStyles.Inner} {
    display: flex;
    flex-direction: column;

    > ${ButtonStyles.Container} {
      margin: ${fluid(40, 76)} auto 0;
    }
  }

  ${FiltersStyles.Container} {
    margin: 0 0 ${fluid(28, 58)};

    @media ${from(Device.TabletLarge)} {
      position: relative;
      z-index: 1;
    }
  }
`;
const ResultsGrid = styled.div `
  --rowItems: 2;

  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: var(--gutterWidth);

  @media ${from(Device.Tablet)} {
    --rowItems: 4;
  }

  @media ${from(Device.DesktopSmall)} {
    --rowItems: 6;
  }

  ${BrandCardStyles.Container} {
    flex: 0 0
      calc(
        100% / var(--rowItems) - (var(--gutterWidth) * ((var(--rowItems) - 1) / var(--rowItems)))
      );
  }
`;
const NoResults = styled.p `
  ${paragraphRegular};

  grid-column: 1 / -1;
  text-align: center;
`;
const BrandCardListingStyles = {
    Container,
    ResultsGrid,
    NoResults,
};
export default BrandCardListingStyles;
